import React, { useEffect, useState } from "react";
import { storeApi } from "@/lib/storeApi";

const n = (v) => (v == null ? "…" : Number(v).toLocaleString("en-GB"));

export default function FleetStats() {
  const [f, setF] = useState(null);
  useEffect(() => {
    storeApi.get("/store/mt5/fleet").then((r) => setF(r.data)).catch(() => {});
  }, []);
  const cells = [
    ["Backtests run", f?.backtests_total, "#FBBF24", "fleet-backtests"],
    ["Real-tick backtests", f?.tick_backtests, "#38BDF8", "fleet-tick"],
    ["Distinct bots bred", f?.bots_total, "#22D3EE", "fleet-bots"],
    ["Symbols tested", f?.symbols_tested, "#D6FF38", "fleet-symbols"],
    ["Passed walk-forward", f?.walk_forward_passed, "#A78BFA", "fleet-wf"],
    ["Net-positive 2025+ backtest", f?.holdout_proven, "#2ECA7F", "fleet-proven"],
  ];
  return (
    <section data-testid="fleet-stats" className="relative z-10 max-w-[1400px] mx-auto px-6 pb-14">
      <div className="mono text-[11px] uppercase tracking-[0.3em] text-[#38BDF8]">Live fleet counter</div>
      <div className="mt-4 grid grid-cols-2 md:grid-cols-6 gap-px bg-blue-900/30 border border-blue-900/40 rounded-xl overflow-hidden">
        {cells.map(([label, v, c, id]) => (
          <div key={id} className="bg-[#050914] p-5">
            <div data-testid={id} className="text-2xl md:text-3xl font-medium tracking-tight" style={{ color: c }}>{n(v)}</div>
            <div className="mono text-[10px] uppercase tracking-widest text-[#94A3B8] mt-1">{label}</div>
          </div>
        ))}
      </div>
      <p className="text-xs text-[#64748B] mt-3 max-w-3xl">
        Research counts, pulled live from our database. All figures are backtests (simulations), not real trading. Most bots are
        rejected and only a few per symbol are listed, so listed results are a selected subset of everything tested.
      </p>
    </section>
  );
}
